module.exports = __webpack_public_path__ + "img/gb93-87_10.prt.799af88c.jpg";